import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useState } from "react";
import { usePasswordRules } from "@jti/rest-api";
import { DEPRECATED_TextInput } from "../../components/DEPRECATED_TextInput";
import { Icon } from "../../components/Icon/Icon";
import { PasswordRequirementsBlock } from "../../components/PasswordRequirementsBlock/PasswordRequirementsBlock";
import EyeClose from "../../icons/eye-closed.svg";
import EyeOpen from "../../icons/eye-open.svg";
import styles from "./Password.module.scss";
/***
 * @deprecated use Password from @jti/ui instead
 */
export const DEPRECATED_Password = forwardRef(({ withValidationRules, ...props }, ref) => {
    const [isVisible, setIsVisible] = useState(false);
    const { isLoading } = usePasswordRules(withValidationRules);
    const toggleVisibility = useCallback(() => {
        setIsVisible((state) => !state);
    }, []);
    const renderValidationRules = () => {
        if (withValidationRules) {
            return _jsx(PasswordRequirementsBlock, { emailValue: props.email, passwordValue: `${props.value || ""}` });
        }
        return _jsx(_Fragment, {});
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.inputWrap, children: [_jsx(DEPRECATED_TextInput, { ...props, className: `${styles.input} ${props.className ? props.className : ""}`, ref: ref, type: isVisible ? "text" : "password", disabled: isLoading && withValidationRules }), _jsx(Icon, { dataTestId: "showPasswordIcon", width: "18px", height: "18px", onClick: toggleVisibility, component: isVisible ? EyeClose : EyeOpen, className: styles.icon })] }), renderValidationRules()] }));
});
//# sourceMappingURL=Password.js.map